import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';

export const usePostHogIdentify = ({ 
  customerId, 
  customerName, 
  merchantId,
  merchantName, 
  branchId,
  organisationId
}, enabled = true) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!enabled || !posthog) return;

    if (customerId && customerName) {
      posthog.identify(customerId, {
        name: customerName,
        ...(merchantName && { merchant_name: merchantName }),
        ...(merchantId && { merchant_id: merchantId }),
        ...(branchId && { branch_id: branchId }),
      });
    }

    if (merchantId && merchantName) {
      posthog.group('merchant', merchantId, {
        name: merchantName,
        ...(organisationId && { short_id: organisationId }),
      });
    }


  }, [posthog, customerId, customerName, merchantId, merchantName, branchId, enabled]);
}; 